/**
 * Returns a depply cloned object without reference.
 * Copied from Vue MultiSelect and Vuex.
 * @type {Object}
 */
export function deepClone (obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepClone)
  } else if (obj && typeof obj === 'object') {
    var cloned = {}
    var keys = Object.keys(obj)
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i]
      cloned[key] = deepClone(obj[key])
    }

    return cloned
  } else {
    return obj
  }
}

export function transformFromFilter (obj) {
  // strip model: ..., where: ... from the object

  return recursiveFromFilter(obj.where[0])
}

function recursiveFromFilter (obj) {
  // add the query keyword structure, to use as initial query
  if (Array.isArray(obj) && (obj[0] != null && !Number.isInteger(obj[0]))) {
    let arr = []
    obj.forEach(function (elem) {
      arr.push({ query: recursiveFromFilter(elem) })
    })

    return arr
  } else if (obj && typeof obj === 'object') {
    let cloned = {}
    let keys = Object.keys(obj)

    if ('operator' in obj && obj['operator'] === 'not') {
      // if not operator, we have to add the 'query: {}'
      cloned = {
        operator: 'not',
        value: {
          query: recursiveFromFilter(obj['value']),
        },
      }
    } else {
      for (let i = 0, l = keys.length; i < l; i++) {
        let key = keys[i]
        cloned[key] = recursiveFromFilter(obj[key])
      }
    }

    return cloned
  } else {
    return obj
  }
}

export function transformToFilter (query, model) {
  return {
    model: model,
    where: [recursiveToFilter(query)],
  }
}

function recursiveToFilter (query) {
  // remove the query keyword structure, to send to the server
  if (Array.isArray(query)) {
    return query.map(recursiveToFilter)
  } else if (query && typeof query === 'object') {
    let cloned = {}
    let keys = Object.keys(query)

    for (let i = 0, l = keys.length; i < l; i++) {
      let key = keys[i]

      if (key === 'query') {
        // remove the query part {query: obj} and also recurse over obj
        return recursiveToFilter(query[key])
      }

      cloned[key] = recursiveToFilter(query[key])
    }

    return cloned
  } else {
    return query
  }
}
